import styled from "styled-components";

export const StyledSearchContainer = styled.div`
  background: #b0e1fb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .search-wrapper {
    width: 65%;
    position: relative;
    flex-grow: 1;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .no-result {
      font-weight: 500;
      font-size: var(--font-size-lg);
      color: var(--text-color-dark);
      @media screen and (max-width: 768px) {
        font-size: var(--font-size-sm);
      }
    }
    .image-background {
      margin: 4rem 0;
    }
    .show-all-result {
      width: 350px;
      margin: 1.5rem 0px;
      @media screen and (max-width: 768px) {
        width: 180px;
      }
    }
  }
`;
